export function useCustomNuxtUtils() {
    const stateKeyPrefix = '$s';
    const nuxtApp = useNuxtApp();

    const isPostServerRendered = computed(() => import.meta.client && !(nuxtApp.isHydrating && nuxtApp.payload.serverRendered));

    function hasOnceKey(key: MaybeRef<string>): boolean {
        return nuxtApp.payload.once.has(unref(key));
    }

    function removeOnceKey(key: MaybeRef<string>): void {
        nuxtApp.payload.once.delete(unref(key));
    }

    function removeOnceKeysByPrefix(prefix: MaybeRef<string>): void {
        prefix = unref(prefix);
        nuxtApp.payload.once.forEach((key) => {
            if (key.startsWith(prefix)) {
                removeOnceKey(key);
            }
        });
    }

    function hasDataKey(key: MaybeRef<string>): boolean {
        return unref(key) in nuxtApp.payload.data;
    }

    function removeDataKey(key: MaybeRef<string>): void {
        key = unref(key);
        delete nuxtApp.payload.data[key];
    }

    function hasStateKey(key: MaybeRef<string>): boolean {
        return `${stateKeyPrefix}${unref(key)}` in nuxtApp.payload.state;
    }

    function removeStateByPrefix(prefix: MaybeRef<string>): void {
        prefix = `${stateKeyPrefix}${unref(prefix)}`;
        Object.keys(nuxtApp.payload.state).forEach((key: string) => {
            if (key.startsWith(prefix)) {
                delete nuxtApp.payload.state[key];
            }
        });
    }

    function clearOnceKeys(): void {
        nuxtApp.payload.once.clear();
    }

    return {
        isPostServerRendered,
        hasOnceKey,
        removeOnceKey,
        removeOnceKeysByPrefix,
        hasDataKey,
        removeDataKey,
        hasStateKey,
        removeStateByPrefix,
        clearOnceKeys
    };
}
